import React, { PropTypes } from 'react';
import { displayCreationModal } from 'saas/contacts/modals';
import { Form } from 'semantic-ui-react';
import Dropdown from 'common/components/Dropdown';

class SiteContact extends React.Component {
  constructor(props) {
    super(props);

    this._onAddContact = this._onAddContact.bind(this);
    this._onContactChange = this._onContactChange.bind(this);
  }

  _onAddContact(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    // Displaying contact modal
    displayCreationModal(this.props.customer, customer => {
      console.log('contact created');
      this.props.onContactAdded(this.props.customer);
    });
  }

  _onContactChange(contact) {
    this.props.onContactChange(this.props.site, {
      contact_id: contact,
    });
  }

  render() {
    const { site, contacts = [] } = this.props;

    const filteredContacts = contacts.filter(
      c => c.is_usable_as_contact_site === true && c.is_deleted === false
    );

    const renderDefault = () => (
      <div className="default text">Choisissez un contact</div>
    );

    const renderContact = contact => (
      <div key={contact.id} data-value={contact.id} className="item">
        {contact.last_name} {contact.first_name}
      </div>
    );

    const contactPhone = () => {
      const current = contacts.find(
        c => c.id === parseInt(site.contact_id, 10)
      );

      if (current) {
        return current.phone;
      }
      return undefined;
    };

    return (
      <div className="ui segment teal lighten">
        <div className="ui grid">
          <div className="four wide column">
            <h4>Adresse</h4>
            {site.address}
            <br />
            {`${site.zipcode || ''} ${site.city || ''}`}
          </div>
          <div className="eight wide column">
            <h4>Contact</h4>
            <div className="ui grid">
              <div className="eight wide column">
                <Form.Field>
                  <Dropdown
                    name={`contact`}
                    value={site.contact_id}
                    items={filteredContacts}
                    renderDefault={renderDefault}
                    renderItem={renderContact}
                    canDelete
                    fluid
                    onChange={this._onContactChange}
                  />
                </Form.Field>
              </div>
              <div className="eight wide column">
                Téléphone: {contactPhone()}
              </div>
            </div>
          </div>
          <div className="four wide column">
            <button
              className="ui right floated labeled icon button"
              onClick={this._onAddContact}
            >
              <i className="icon add" />
              Ajouter un contact site
            </button>
          </div>
        </div>
      </div>
    );
  }
}

SiteContact.propTypes = {
  contacts: PropTypes.array.isRequired,
  site: PropTypes.object.isRequired,
  onContactChange: PropTypes.func.isRequired,
  onContactAdded: PropTypes.func.isRequired,
};

SiteContact.childContextTypes = {
  customer: PropTypes.string.isRequired,
};

export default SiteContact;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/SiteContact.js